import React, { useEffect, useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'
import usePinnedFeatureFlag from '../../hooks/usePinnedFeatureFlag'
import { UI_KIT_BUTTON, UI_KIT_CONFIRM } from '../../config/featureFlagKeys'
import { selectFeatureFlag, selectFeatureFlagsSettled } from '../../features/featureFlags/selectors'
import { UiKitContext } from './UiKitContext'

const INTERACTIONS = ['pointerdown', 'keydown', 'click']

const useConfirmFlag = () => {
  const live = useSelector(selectFeatureFlag(UI_KIT_CONFIRM))
  const settled = useSelector(selectFeatureFlagsSettled)
  const latest = useRef({ live, settled })
  const pinned = useRef(null)
  const interacted = useRef(false)

  latest.current = { live, settled }
  if (pinned.current === null && settled && interacted.current) pinned.current = live

  useEffect(() => {
    const lock = () => {
      interacted.current = true
      if (pinned.current === null && latest.current.settled) pinned.current = latest.current.live
      INTERACTIONS.forEach((name) => window.removeEventListener(name, lock, true))
    }
    INTERACTIONS.forEach((name) => window.addEventListener(name, lock, true))
    return () => INTERACTIONS.forEach((name) => window.removeEventListener(name, lock, true))
  }, [])

  if (pinned.current !== null) return pinned.current === true
  return settled && live === true
}

const UiKitProvider = ({ children }) => {
  const { enabled: button } = usePinnedFeatureFlag(UI_KIT_BUTTON)
  const confirm = useConfirmFlag()
  const value = useMemo(() => ({ button, confirm }), [button, confirm])

  return <UiKitContext.Provider value={value}>{children}</UiKitContext.Provider>
}

export default UiKitProvider
